import { Context } from '@alltrails/shared/types/context';
import usePathname from 'hooks/usePathname';
import { Page } from 'components/shared/Page/Page';
import Router from '@alltrails/shared/components/ReactRouter';
import ProComparison from 'components/welcome/ProComparison';
import PlusFeatureCarousel from 'components/welcome/PlusFeatureCarousel';
import OnePercentBlock from 'components/blocks/OnePercentBlock';
import AppDownloadAndReview from 'components/welcome/AppDownloadAndReview';
import WelcomeHeaderVariant from 'components/welcome/WelcomeHeaderVariant';
import WelcomeHeader from 'components/welcome/WelcomeHeader';
import classNames from 'classnames';
import * as styles from './styles.module.scss';
import CountryCode from 'types/CountryCode';

// US & UK variant https://www.figma.com/file/qjIIfs4kouoaF41wVeKWBq/SEM-Lander?node-id=215%3A6629&t=5sMltY3ooTz3KVXO-0
// All other coutries variant https://app.zeplin.io/project/62fa750b146112154d3f7729

type WelcomeProps = {
  context: Context;
};

const Welcome = ({ context }: WelcomeProps): JSX.Element => {
  const fullpath = usePathname();
  const { ipCountry } = __AT_DATA__;

  const countryCode: CountryCode = 'US';
  const showVariant = ipCountry === countryCode;

  return (
    <div>
      <Page context={context}>
        <Router fullpath={fullpath}>
          <div className={classNames({ [styles.innerContainer]: true, [styles.mobileContainer]: showVariant })}>
            {showVariant ? <WelcomeHeaderVariant /> : <WelcomeHeader />}
            {showVariant ? (
              <>
                <ProComparison />
                <PlusFeatureCarousel showVariant />
              </>
            ) : (
              <>
                <PlusFeatureCarousel />
                <ProComparison />
              </>
            )}
            <AppDownloadAndReview />
          </div>
          <OnePercentBlock />
        </Router>
      </Page>
    </div>
  );
};

export default Welcome;
